import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6f0b1d1d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "params-form-group"
};
const _hoisted_2 = {
  class: "header mg-b--10"
};
const _hoisted_3 = {
  class: "cms-module-title"
};
const _hoisted_4 = {
  key: 1,
  style: {
    "height": "32px"
  }
};
const _hoisted_5 = ["width"];
const _hoisted_6 = {
  key: 0,
  class: "delete-btn"
};
const _hoisted_7 = ["onClick"];
import BaseFormItem from './BaseFormItem.vue';
import { reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { getItemByProp } from '@/utils/tools';
export default /*#__PURE__*/_defineComponent({
  __name: 'ParamsFormGroup',
  props: {
    action: {
      type: String,
      default: 'edit' //  edit 新增或编辑 check 查看

    },
    formMaxHeight: {
      type: [String, Number],
      default: 470
    },
    formData: {
      type: Array,
      default: [{
        codeType: 'h264',
        resolutionRatio: '240p',
        codeRate: '500K'
      }]
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const paramsFormGroupRef = ref(null);
    const formConfig = reactive({
      formList: [[{
        label: '编码标准',
        prop: 'codeType',
        widgetType: 'Select',
        required: true,
        list: [{
          label: 'H.264',
          value: 'h264'
        }, {
          label: 'H.265',
          value: 'h265'
        }],
        controller: (value, data, config) => {
          // console.log(value, data, config);
          if (props.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = true;
            config.widgetType = 'Select';
          }

          return true;
        },
        formatter: val => {
          if (props.action == 'check') {
            return val == 'h264' ? 'H.264' : val == 'h265' ? 'H.265' : '--';
          } else {
            return val;
          }
        },
        rules: props.action == 'check' ? [] : [{
          required: true,
          message: t('请选择编码标准'),
          trigger: 'change'
        }]
      }], [{
        label: '分辨率',
        prop: 'resolutionRatio',
        widgetType: 'Select',
        required: true,
        // valueKey: 'type', labelKey: 'broadCastType',
        formatter: val => {
          if (props.action == 'check') {
            if (val) {
              let item = getItemByProp(formConfig.formList, 'resolutionRatio');
              const fItem = item.list.find(f => f.value == val);
              return fItem ? fItem.label : '--';
            } else {
              return '--';
            }
          } else {
            return val;
          }
        },
        list: [{
          label: '480x270',
          value: '240p'
        }, // { label: '640x360', value: '360p' },
        {
          label: '854x480',
          value: '480p'
        }, // { label: '720x576', value: '576p' },
        {
          label: '1280x720',
          value: '720p'
        }, {
          label: '1920x1080',
          value: '1080p'
        }, {
          label: '2560x1440',
          value: '2k'
        }, {
          label: '3840x2160',
          value: '4k'
        }],
        controller: (value, data, config) => {
          if (props.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = true;
            config.widgetType = 'Select';
          }

          return true;
        },
        rules: props.action == 'check' ? [] : [{
          required: true,
          message: t('请选择分辨率'),
          trigger: 'change'
        }]
      }], [{
        label: '码率',
        prop: 'codeRate',
        widgetType: 'Select',
        required: true,
        list: [{
          label: '200K',
          value: '200K'
        }, {
          label: '300K',
          value: '300K'
        }, {
          label: '500K',
          value: '500K'
        }, {
          label: '512K',
          value: '512K'
        }, {
          label: '600K',
          value: '600K'
        }, {
          label: '700K',
          value: '700K'
        }, {
          label: '1000K',
          value: '1000K'
        }, {
          label: '1024K',
          value: '1024K'
        }, {
          label: '2048K',
          value: '2048K'
        }, {
          label: '2100K',
          value: '2100K'
        }, {
          label: '3000K',
          value: '3000K'
        }, {
          label: '3072K',
          value: '3072K'
        }, {
          label: '4096K',
          value: '4096K'
        }, {
          label: '4900K',
          value: '4900K'
        }, {
          label: '5120K',
          value: '5120K'
        }, {
          label: '5600K',
          value: '5600K'
        }, {
          label: '7000K',
          value: '7000K'
        }, {
          label: '8000K',
          value: '8000K'
        }],
        controller: (value, data, config) => {
          if (props.action == 'check') {
            config.required = false;
            config.widgetType = 'text';
          } else {
            config.required = true;
            config.widgetType = 'Select';
          }

          return true;
        },
        rules: props.action == 'check' ? [] : [{
          required: true,
          message: t('请选择码率'),
          trigger: 'change'
        }]
      }], [{
        label: '帧率',
        prop: 'frameRate',
        widgetType: 'input',
        controller: (value, data, config) => {
          config.widgetType = props.action == 'check' ? 'text' : 'input';
          return true;
        }
      }]],
      formData: []
    });
    const loading = ref(false);
    watch(() => props.formData, val => {
      if (val && val.length) {
        loading.value = true;
        setTimeout(() => {
          formConfig.formData = JSON.parse(JSON.stringify(props.formData));
          loading.value = false;
        }, 200);
      } else {
        formConfig.formData = [{
          codeType: 'h264',
          resolutionRatio: '240p',
          codeRate: '500K',
          frameRate: 25
        }];
      }
    }, {
      immediate: true,
      deep: true
    }); // 新增

    const addFormItem = () => {
      formConfig.formData.push({
        codeType: 'h264',
        resolutionRatio: '240p',
        codeRate: '500K',
        frameRate: 25
      });
      setTimeout(() => {
        let scrollView = document.querySelector('#el-form');
        scrollView ? scrollView.scrollTop = scrollView.scrollHeight : '';
      }, 100);
    }; // 删除


    const handleDeleteItem = index => {
      formConfig.formData.splice(index, 1);
    };

    expose({
      paramsFormGroupRef,
      formConfig
    }); // onMounted(() => {
    //     getBroadCastList();
    // })

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('输出参数')), 1), __props.action == 'edit' && formConfig.formData.length < 10 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "add-btn",
        type: "primary",
        onClick: addFormItem
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('添加')), 1)]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_4))]), _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        style: _normalizeStyle(`max-height:${__props.formMaxHeight}px`),
        model: formConfig.formData,
        ref_key: "paramsFormGroupRef",
        ref: paramsFormGroupRef,
        id: "el-form"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formData, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "table-item mg-b--10",
            key: index
          }, [_createElementVNode("table", {
            style: _normalizeStyle(__props.action == 'edit' && formConfig.formData.length > 1 ? 'width: calc(100% - 6.25vw);' : ''),
            class: "cms-data-info-table",
            cellspacing: "0",
            cellpadding: "0"
          }, [_createElementVNode("colgroup", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formData.length > 1 ? ['30%', '55%'] : ['30%', '70%'], c => {
            return _openBlock(), _createElementBlock("col", {
              width: c
            }, null, 8, _hoisted_5);
          }), 256))]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList || [], (formItem, formIndex) => {
            return _openBlock(), _createBlock(BaseFormItem, {
              key: formIndex,
              "form-item": formItem,
              "form-data": formConfig.formData[index],
              c_index: index
            }, null, 8, ["form-item", "form-data", "c_index"]);
          }), 128))])], 4), __props.action == 'edit' && formConfig.formData.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", {
            class: "pointer",
            onClick: $event => handleDeleteItem(index)
          }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_7)])) : _createCommentVNode("", true)]);
        }), 128))]),
        _: 1
      }, 8, ["style", "model"])), [[_directive_loading, loading.value]])]);
    };
  }

});